import { Fragment } from "react";
import StudentMerge from "../../api/models/studentMerge";
import moment from "moment";
import SubmitButton from "../submitButton";
type Props = {
    studentFrom?: StudentMerge,
    studentTo?: StudentMerge,
    setStudentFrom: (student: StudentMerge | undefined) => void;
    setStudentTo: (student: StudentMerge | undefined) => void;
};
const StudentMergeModel = (
    {
        studentFrom,
        studentTo,
        setStudentFrom,
        setStudentTo
    }: Props
) => {
    return (
        <Fragment>
            {/* Student to Keep Section */}
            <div style={{ width: '75% !importent' }} className="border border-green-500 bg-green-100 p-2 rounded-lg shadow">
                <div className="flex justify-between items-center">
                    <button className="text-xs bg-green-500 text-white px-3 py-1 rounded">✓ Student to Keep</button>
                    <button className="text-xs text-white bg-red-500 hover:text-black" onClick={() => setStudentTo(undefined)}>✖ Clear Selection</button>
                </div>
                <p className="text-xs text-gray-600 mt-1">MyPTS ID: <b>{studentTo?.studentId}</b> | DoB: {moment(studentTo?.dob.toString()).format('MM/DD/YYYY')} | Added: {moment(studentTo?.createdOn.toString()).format('MM/DD/YYYY')} | Created By: {studentTo?.createdByUserFirstName}
                    {" " + studentTo?.createdByUserLastName} | District: {studentTo?.DistrictName}</p>

                <h2 className="text-sm font-semibold mt-1">{studentTo?.firstName + " " + studentTo?.lastName}</h2>

                {/* Student Schools */}
                <div className="bg-gray-100 p-2 mt-1 rounded-md shadow">
                    <h3 className="text-sm font-semibold">Schools</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-2 text-gray-700 list-disc pl-4">
                        {studentTo?.studentMergeSchools.map((row, i) => {
                            return (
                                <li className='text-xs' key={i}>
                                    {row.name}:
                                    {moment(row.startDate?.toString()).format('MM/DD/YYYY')} - {moment(row.endDate?.toString()).format('MM/DD/YYYY')}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* Student Therapist */}
                <div className="bg-gray-100 p-1 mt-1 rounded-md shadow">
                    <h3 className="text-sm font-semibold">Therapists</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-1 text-gray-700 list-disc pl-4">
                        {studentTo?.studentMergeDisciplines.map((row, i) => {
                            return (
                                <li key={i}>
                                    <ul className="mt-1 text-gray-700 list-disc pl-1">
                                        <p className="text-sm font-semibold text-blue-600">{row.disciplineName}</p>
                                        <ul>
                                            {row.studentMergeTherapists.map((therapist, indx) => {
                                                return (
                                                    <li key={indx}>
                                                        <p className="text-xs text-gray-600">{row.studentStatusName}: {moment(therapist.startDate?.toString()).format('MM/DD/YYYY')} - {moment(therapist.endDate?.toString()).format('MM/DD/YYYY')}</p>
                                                        <p className="text-xs text-gray-500">Therapist: {therapist.therapistRoleName}: {therapist.therapistFirstName + " " + therapist.therapistLastName}</p>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* Time Billed Section */}
                <div className="mt-1 bg-gray-200 p-2 rounded">
                    <h3 className="text-sm font-semibold">Time Billed</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-1 text-gray-700 list-disc pl-4">
                        {
                            (studentTo?.studentMergeBillings === undefined || studentTo?.studentMergeBillings.length === 0) ? (
                                <p className="text-xs text-gray-700 italic">No time entered</p>
                            ) : (
                                studentTo?.studentMergeBillings.map((row, i) => {
                                    return (
                                        <li key={i}>
                                            <p className="text-xs text-gray-700">{row.therapistFirstName + " " + row.therapistLastName} ({row.disciplineName}) - {row.schoolName}:</p>
                                            <ul className="text-xs text-gray-600 list-disc ml-4">
                                                {row.individualTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li key={iIndex}>
                                                            Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY') + " - " + moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}: {iTime.taskTypeName + "-" + iTime.entryTypeName}
                                                        </li>
                                                    )
                                                })}
                                                {row.groupTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li key={iIndex}>
                                                            Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY') + " - " + moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}: {"Group Time"}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </li>

                                    );
                                }))
                        }
                    </ul>
                </div>
                {/* <button className="mt-4 bg-yellow-500 text-white px-4 py-2 rounded"></button> */}
            </div>
            <div className='py-1 mt-1 text-center bg-white'>
                <SubmitButton
                    text='⇅ Switch'
                    className='button text-xs'
                    onClick={() => {
                        if (studentFrom != null || studentTo != null) {
                            setStudentFrom(studentTo);
                            setStudentTo(studentFrom);
                        }
                    }}
                />
            </div>
            {/* Student to Discard Section */}
            <div style={{ width: '75% !importent' }} className="border border-red-500 bg-red-100 p-2 rounded-lg shadow">
                <div className="flex justify-between items-center">
                    <button className="text-xs bg-green-500 text-white px-3 py-1 rounded">✗ Student to Discard</button>
                    <button className="text-xs text-white bg-red-500 hover:text-black" onClick={() => setStudentFrom(undefined)}>✖ Clear Selection</button>
                </div>
                <p className="text-xs text-gray-600 mt-1">MyPTS ID: <b>{studentFrom?.studentId}</b> | DoB: {moment(studentFrom?.dob.toString()).format('MM/DD/YYYY')} | Added: {moment(studentFrom?.createdOn.toString()).format('MM/DD/YYYY')} | Created By: {studentFrom?.createdByUserFirstName}
                    {" " + studentFrom?.createdByUserLastName} | District: {studentFrom?.DistrictName}</p>

                <h2 className="text-sm font-semibold mt-1">{studentFrom?.firstName + " " + studentFrom?.lastName}</h2>

                {/* Student Schools */}
                <div className="bg-gray-100 p-2 mt-1 rounded-md shadow">
                    <h3 className="text-sm font-semibold">Schools</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-2 text-gray-700 list-disc pl-4">
                        {studentFrom?.studentMergeSchools.map((row, i) => {
                            return (
                                <li className='text-xs' key={i}>
                                    {row.name}:
                                    {moment(row.startDate?.toString()).format('MM/DD/YYYY')} - {moment(row.endDate?.toString()).format('MM/DD/YYYY')}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* Student Therapist */}
                <div className="bg-gray-100 p-1 mt-1 rounded-md shadow">
                    <h3 className="text-sm font-semibold">Therapists</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-1 text-gray-700 list-disc pl-4">
                        {studentFrom?.studentMergeDisciplines.map((row, i) => {
                            return (
                                <li key={i}>
                                    <ul className="mt-1 text-gray-700 list-disc pl-1">
                                        <p className="text-sm font-semibold text-blue-600">{row.disciplineName}</p>
                                        <ul>
                                            {row.studentMergeTherapists.map((therapist, indx) => {
                                                return (
                                                    <li key={indx}>
                                                        <p className="text-xs text-gray-600">{row.studentStatusName}: {moment(therapist.startDate?.toString()).format('MM/DD/YYYY')} - {moment(therapist.endDate?.toString()).format('MM/DD/YYYY')}</p>
                                                        <p className="text-xs text-gray-500">Therapist: {therapist.therapistRoleName}: {therapist.therapistFirstName + " " + therapist.therapistLastName}</p>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* Time Billed Section */}
                <div className="mt-1 bg-gray-200 p-2 rounded">
                    <h3 className="text-sm font-semibold">Time Billed</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-1 text-gray-700 list-disc pl-4">
                        {
                            (studentFrom?.studentMergeBillings === undefined || studentFrom?.studentMergeBillings.length === 0) ? (
                                <p className="text-xs text-gray-700 italic">No time entered</p>
                            ) : (
                                studentFrom?.studentMergeBillings.map((row, i) => {
                                    return (
                                        <li key={i}>
                                            <p className="text-xs text-gray-700">{row.therapistFirstName + " " + row.therapistLastName} ({row.disciplineName}) - {row.schoolName}:</p>
                                            <ul className="text-xs text-gray-600 list-disc ml-4">
                                                {row.individualTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li key={iIndex}>
                                                            Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY') + " - " + moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}: {iTime.taskTypeName + "-" + iTime.entryTypeName}
                                                        </li>
                                                    )
                                                })}
                                                {row.groupTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li key={iIndex}>
                                                            Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY') + " - " + moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}: {"Group Time"}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </li>

                                    );
                                }))
                        }
                    </ul>
                </div>
                {/* <button className="mt-4 bg-yellow-500 text-white px-4 py-2 rounded"></button> */}
            </div>

            {/* <div className="border border-red-500 bg-red-100 p-4 rounded-lg shadow">
                <div className="flex justify-between items-center">
                    <button className="bg-orange-500 text-white px-3 py-1 rounded">✗ Student to Discard</button>
                    <button className="text-sm text-white bg-red-500 hover:text-black" onClick={() => setStudentTo(undefined)}>✖ Clear Selection</button>
                </div>
                <p className="text-sm text-gray-600 mt-2">MyPTS ID: <b>{studentTo?.studentId}</b> | DoB: {moment(studentTo?.dob.toString()).format('MM/DD/YYYY')} | Added: {moment(studentTo?.createdOn.toString()).format('MM/DD/YYYY')} | Created By: {studentTo?.createdByUserFirstName}
                    {" " + studentTo?.createdByUserLastName} | District: {studentTo?.homeDistrictName}</p>

                <h2 className="text-lg font-semibold mt-4">{studentTo?.firstName + " " + studentTo?.lastName}</h2>
                <div className="bg-gray-100 p-4 mt-2 rounded-md shadow">
                    <h3 className="font-semibold">Schools</h3>
                    {(studentTo?.studentMergeSchools.length === 0 || studentTo?.studentMergeSchools === undefined)
                        ? (
                            <p className="text-sm text-gray-700 italic">No Data Found</p>
                        ) : (
                            <ul className="mt-2 text-gray-700 list-disc pl-4">
                                {studentTo?.studentMergeSchools.map((row, i) => {
                                    return (
                                        <li>
                                            {row.name}:
                                            {moment(row.startDate?.toString()).format('MM/DD/YYYY')} - {moment(row.endDate?.toString()).format('MM/DD/YYYY')}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}

                </div>
                <div className="bg-gray-100 p-4 mt-2 rounded-md shadow">
                    <h3 className="font-semibold">Therapists</h3>
                    {(studentTo?.studentMergeDisciplines.length === 0 || studentTo?.studentMergeDisciplines === undefined)
                        ? (
                            <p className="text-sm text-gray-700 italic">No Data Found</p>
                        ) : (
                            <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-2 text-gray-700 list-disc pl-4">
                                {studentTo?.studentMergeDisciplines.map((row, i) => {
                                    return (
                                        <li>
                                            <ul className="mt-2 text-gray-700 list-disc pl-4">
                                                <p className="font-semibold text-blue-600">{row.disciplineName}</p>
                                                <ul>
                                                    {row.studentMergeTherapists.map((therapist, i) => {
                                                        return (
                                                            <li>
                                                                <p className="text-sm text-gray-600">{row.studentStatusName}: {moment(therapist.startDate?.toString()).format('MM/DD/YYYY')} - {moment(therapist.endDate?.toString()).format('MM/DD/YYYY')}</p>
                                                                <p className="text-sm text-gray-500">Therapist: {therapist.therapistRoleName}: {therapist.therapistFirstName + " " + therapist.therapistLastName}</p>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </ul>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                </div>*/}
            {/* Time Billed Section 
                <div className="mt-4 bg-gray-200 p-3 rounded">
                    <h3 className="font-semibold">Time Billed</h3>
                    <ul style={{ maxHeight: '8rem', overflow: 'auto' }} className="mt-2 text-gray-700 list-disc pl-4">
                        {
                            (studentTo?.studentMergeBillings === undefined || studentTo?.studentMergeBillings?.length === 0) ? (
                                <p className="text-sm text-gray-700 italic">No time entered</p>
                            ) : (
                                studentTo?.studentMergeBillings.map((row, i) => {
                                    return (
                                        <li>
                                            <p className="text-sm text-gray-700">{row.therapistFirstName + " " + row.therapistLastName} ({row.disciplineName}) - {row.schoolName}:</p>
                                            <ul className="text-sm text-gray-600 list-disc ml-4">
                                                {row.individualTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li>Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY')} – {moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}: {iTime.taskTypeName + "-" + iTime.entryTypeName}</li>
                                                    )
                                                })}
                                                {row.groupTimes.map((iTime, iIndex) => {
                                                    return (
                                                        <li>Billed {moment(iTime?.startDate.toString()).format('MM/DD/YYYY')} – {moment(iTime?.endDate.toString()).format('MM/DD/YYYY')}</li>
                                                    )
                                                })}
                                            </ul>
                                        </li>

                                    );
                                }))
                        }
                    </ul>
                </div>
            </div> */}
        </Fragment >
    )
}

export default StudentMergeModel;